module.exports = __webpack_public_path__ + "static/img/item6.9804742.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big_picture/item6.png
// module id = 0Bf+
// module chunks = 0